var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interval"},[_vm._t("default",null,{"val":_vm.val,"pause":_vm.pause})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }